import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AiCopilotTranslateMutationVariables = Types.Exact<{
  args: Types.TranslateInput;
}>;


export type AiCopilotTranslateMutation = { __typename?: 'Mutation', aiCopilotTranslate?: { __typename?: 'OmsAiCopilotTranslatePayload', responseId: string, status: string, translation?: string | null } | null };


export const AiCopilotTranslateDocument = gql`
    mutation aiCopilotTranslate($args: TranslateInput!) {
  aiCopilotTranslate(input: {args: $args}) {
    responseId
    status
    translation
  }
}
    `;
export type AiCopilotTranslateMutationFn = Apollo.MutationFunction<AiCopilotTranslateMutation, AiCopilotTranslateMutationVariables>;

/**
 * __useAiCopilotTranslateMutation__
 *
 * To run a mutation, you first call `useAiCopilotTranslateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiCopilotTranslateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiCopilotTranslateMutation, { data, loading, error }] = useAiCopilotTranslateMutation({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useAiCopilotTranslateMutation(baseOptions?: Apollo.MutationHookOptions<AiCopilotTranslateMutation, AiCopilotTranslateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiCopilotTranslateMutation, AiCopilotTranslateMutationVariables>(AiCopilotTranslateDocument, options);
      }
export type AiCopilotTranslateMutationHookResult = ReturnType<typeof useAiCopilotTranslateMutation>;
export type AiCopilotTranslateMutationResult = Apollo.MutationResult<AiCopilotTranslateMutation>;
export type AiCopilotTranslateMutationOptions = Apollo.BaseMutationOptions<AiCopilotTranslateMutation, AiCopilotTranslateMutationVariables>;